<template>
	<!DOCTYPE html>
	<html lang="zh">
	<head>
		<meta charset="UTF-8">
		<meta name="viewport" content="width=device-width, initial-scale=1.0">
		<meta http-equiv="X-UA-Compatible" content="ie=edge">
		<title></title>
		<link href="/index/element-ui.css" rel="stylesheet">
		<link rel="stylesheet" type="text/css" href="/index/reset.css">
		<link rel="stylesheet" type="text/css" href="/index/index.css">
		<link rel="stylesheet" type="text/css" href="/index/index_mb.css">
		<link rel="stylesheet" type="text/css" href="/index/animate.min.css">
		<link rel="stylesheet" type="text/css" href="/index/swiper.min.css">
	</head>
	<body>
		<!--banner-->
		<div class="bannerbox">
		    <!--pc-->
		    <div id="banner" class="banner swiper-container">
		        <div class="swiper-wrapper">
		            <div class="swiper-slide">
						<router-link to='/index'>
							<img src="/index/banner_01.jpg">
							<img src="/index/banner_02.jpg">
							<img src="/index/banner_03.jpg">
							<img src="/index/banner_04.jpg">
						</router-link>
		                <!-- <a href="http://data.minijd.com/Account/register?role=2&amp;i=">
		                    <img src="/index/banner_01.jpg">
		                    <img src="/index/banner_02.jpg">
		                    <img src="/index/banner_03.jpg">
		                    <img src="/index/banner_04.jpg">
		                </a> -->
		            </div>
		        </div>
		        <!-- <div class="swiper-button-prev swiper-button-white"></div> -->
		        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
		        <!-- <div class="swiper-button-next swiper-button-white"></div> -->
		        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
		    </div>
		    <!--mb-->
		    <div id="banner2" class="banner swiper-container">
		        <div class="swiper-wrapper">
		            <div class="swiper-slide">
		                <img src="/index/mb-banner_01_01.jpg">
		                <img src="/index/mb-banner_01_02.jpg">
		                <img src="/index/mb-banner_01_03.jpg">
		                <img src="/index/mb-banner_01_04.jpg">
		                <img src="/index/mb-banner_01_05.jpg">
		                <img src="/index/mb-banner_01_06.jpg">
		            </div>
		        </div>
		        <!-- <div class="swiper-button-prev swiper-button-white"></div>
		        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
		        <!-- <div class="swiper-button-next swiper-button-white"></div> -->
		        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
		    </div>
		    <!-- <script language="javascript">
		        var mySwiper = new Swiper('.banner', {
		            loop: true,
		            autoplay: true,
		            navigation: {
		                nextEl: '.swiper-button-next',
		                prevEl: '.swiper-button-prev',
		            },
		        });
		    </script> -->
		    <div class="top-box">
		        <!--top-->
		        <div class="top">
		            <div class="container">
					<!--logo-->
						<!--pc-->
		                <div id="logo" class="top-left wow bounceInUp animated" style="visibility: visible;">
							<router-link to='/index'>
								<img src="/index/logo.png" style="width:450px;height:90px">
							</router-link>
		                </div>
						<!--mb-->
		                <div id="logo2" class="top-left wow bounceInUp animated" style="visibility: visible;">
							<router-link to='/index'>
								<img src="/index/logo.png" style="width:225px;height:45px">
							</router-link>
		                </div>
		                <div class="top-right diaocha-img wow bounceInRight animated" style="visibility: visible;">
							<router-link to='/login'>
								快速注册
							</router-link>
		                    <!-- <a href="http://data.minijd.com/Account/register?role=2&amp;i=">快速注册</a> -->
							<router-link style="background: #FF6633;background-image: linear-gradient(to right, #FF6633 , #FF9933);border-left: 1px #FFFFFF solid;box-sizing: border-box;" to='/login'>
								马上登陆
							</router-link>
		                    <!-- <a style="background: #FF6633;background-image: linear-gradient(to right, #FF6633 , #FF9933);border-left: 1px #FFFFFF solid;box-sizing: border-box;" href="http://data.minijd.com/Account/Login">马上登陆</a> -->
		                </div>
		            </div>
		        </div>
		        <!--top-->
		        <!--nav-->
		        <div class="nav-box diaocha-title wow bounceInUp animated" style="visibility: visible;">
		            <div class="nav-bg"></div>
		            <div class="nav">
		                <div class="container">
		                    <ul>
		                        <li><router-link to="/index"></router-link></li>
		                        <li>/</li>
		                        <li><a href="javascript:;" @click="md('dujiayoushi')"></a></li>
		                        <li>/</li>
		                        <li><a href="javascript:;" @click="md('hexinziyuan')"></a></li>
		                        <li>/</li>
		                        <li><a href="javascript:;" @click="md('liuchengyanshi')"></a></li>
		                        <li>/</li>
		                        <li><a href="javascript:;" @click="md('anlifankui')"></a></li>
		                    </ul>
		                </div>
		            </div>
		        </div>
		        <!--nav end-->
		    </div>
		</div>
		<!--banner end-->
		<!--pingtai-->
		<div class="pingtai">
		    <div class="title wow bounceInRight animated" style="visibility: visible;">
		        <h1></h1>
		        <h2></h2>
		        <h3></h3>
		    </div>
		    <div class="container wow bounceInUp imghover animated" style="visibility: visible;">
		        <ul>
		            <li>
		                <h1><img src="/index/zr.png"></h1>
		                <h2></h2>
		            </li>
		            <li>
		                <h1><img src="/index/zr-02.png"></h1>
		                <h2></h2>
		            </li>
		            <li>
		                <h1><img src="/index/zr-03.png"></h1>
		                <h2></h2>
		            </li>
		            <li style="border: none;">
		                <h1><img src="/index/zr-04.png"></h1>
		                <h2></h2>
		            </li>
		        </ul>
		    </div>
		</div>
		<!--pingtai end-->
		<!--zhandian-->
		<div class="zhandian">
		    <div class="title wow bounceInRight animated" style="visibility: visible;">
		        <h1></h1>
		        <h2></h2>
		        <h3></h3>
		    </div>
		    <div class="container">
		        <ul class="wow bounceInUp imghover">
		            <li>
		                <h1><img src="/index/gq.png"></h1>
		                <h2>菲律宾</h2>
		                <h3>Philippines</h3>
		            </li>
		            <li>
		                <h1><img src="/index/gq-06.png"></h1>
		                <h2>泰国</h2>
		                <h3>Thailand</h3>
		            </li>
		            <li>
		                <h1><img src="/index/gq-07.png"></h1>
		                <h2>马来</h2>
		                <h3>Malaysia</h3>
		            </li>
		            <li>
		                <h1><img src="/index/gq-08.png"></h1>
		                <h2>印尼</h2>
		                <h3>Indonesia</h3>
		            </li>
					<!--
		            <li>
		                <h1><img src="Image/TempOne/gq-09.png" /></h1>
		                <h2>新加坡</h2>
		                <h3>Singapore</h3>
		            </li>
		            <li>
		                <h1><img src="Image/TempOne/gq-10.png" /></h1>
		                <h2>越南</h2>
		                <h3>Vietnam</h3>
		            </li>
		            <li>
		                <h1><img src="Image/TempOne/gq-11.png" /></h1>
		                <h2>台湾</h2>
		                <h3>Taiwan</h3>
		            </li>
					-->
		        </ul>
		
		    </div>
		
		</div>
		<div class="zhandian2">
		    <div class="container wow bounceInUp">
		        <img src="/index/yz.png">
		    </div>
		</div>
		<div class="container">
		    <div class="zhandian3 wow bounceInUp">
		        <ul>
		            <li>
		                <h1><img src="/index/yz-b.png"></h1>
		                <h2></h2>
		            </li>
		            <li>
		                <h1><img src="/index/yz-b-14.png"></h1>
		                <h2> </h2>
		            </li>
		            <li>
		                <h1><img src="/index/yz-b-15.png"></h1>
		                <h2></h2>
		            </li>
		            <li>
		                <h1><img src="/index/yz-b-16.png"></h1>
		                <h2></h2>
		            </li>
		        </ul>
		    </div>
		</div>
		<div class="container">
		    <div class="zhandian4 imghover wow bounceInUp">
		        <img src="/index/budan_56.png">
		    </div>
		</div>
		<!--zhandian end-->
		<!--youshi-->
		<div class="youshi" id="dujiayoushi">
		    <div class="container">
		        <div class="title wow bounceInRight">
		            <h2 style="color: #FFFFFF;"></h2>
		            <h1 style="color: #FFFFFF;font-size: 1rem;"></h1>
		        </div>
		        <div class="youshi-img wow bounceInRight">
		            <img src="/index/youshi.png">
		        </div>
		        <div class="youshi-img2 wow bounceInRight animated" style="visibility: visible;">
		            <img src="/index/mb-youshi_04.png">
		        </div>
		    </div>
		</div>
		<!--youshi end-->
		<!--zizhu-->
		<div class="zizhu" id="liuchengyanshi">
		    <div class="title wow bounceInRight">
		        <h1></h1>
		        <h2></h2>
		        <h3></h3>
		    </div>
		    <div class="container wow bounceInUp">
		        <img class="zizhuimg" src="/index/zizhu.png">
		        <img class="zizhuimg2" src="/index/mb-zizhu_05.png">
		    </div>
		</div>
		<!--zizhu end-->
		<!--hexin-->
		<div class="hexin" id="hexinziyuan">
		    <div class="container">
		        <div class="title wow bounceInRight">
		            <h2></h2>
		            <h1 style="font-size: 1rem;"></h1>
		            <h3></h3>
		        </div>
		        <ul class="wow bounceInUp">
		            <li>
		                <h1><img src="/index/hexin.png"></h1>
		                <h2></h2>
		                <p></p>
		            </li>
		            <li>
		                <h1><img src="/index/hexin-20.png"></h1>
		                <h2></h2>
		                <p></p>
		            </li>
		            <li>
		                <h1><img src="/index/hexin-21.png"></h1>
		                <h2></h2>
		                <p></p>
		            </li>
		            <li>
		                <h1><img src="/index/hexin-22.png"></h1>
		                <h2></h2>
		                <p></p>
		            </li>
		            <li>
		                <h1><img src="/index/hexin-23.png"></h1>
		                <h2></h2>
		                <p></p>
		            </li>
		            <li>
		                <h1><img src="/index/hexin-24.png"></h1>
		                <h2></h2>
		                <p></p>
		            </li>
		        </ul>
		    </div>
		</div>
		<!--hexin end-->
		<!--maishou-->
		<div class="maishou" id="anlifankui">
		    <div class="container">
		        <div class="title wow bounceInRight">
		            <h1></h1>
		            <h2></h2>
		            <h3></h3>
		            <h4></h4>
		        </div>
		        <div class="maishou-img">
		            <img src="/index/maishou.jpg">
		        </div>
		    </div>
		</div>
		<!--maishou end-->
		<!--footer-->
		<div class="footer">
		    <div class="container">
				<router-link to='/login'>
					<img src="/index/budan_86.png">
				</router-link>
		    </div>
		</div>
		<!--footer end-->
		<!--kefu-->
		<div class="kefu">
		    <div class="kefu-img">
		        <img src="/index/kefu.png">
		    </div>
		    <div class="kefu-nav">
		        <ul>
		            <li>
						<a :href="kf.qq_url">QQ:{{kf.qq}}</a>
					</li>
		            <li><a href="javascript:;">电话:{{kf.mobile}}</a></li>
		            <li><a href="javascript:;"><img :src="kf.wx" style="width:135px"></a></li>
		        </ul>
		    </div>
		</div>
		<!--kefu end-->
	</body>
	</html>
</template>
<!--加载特效js-->
<script>
	// if (!(/msie [6|7|8|9]/i.test(navigator.userAgent))) {
	// 	new WOW().init();
	// };
	import { goAnchor, GetQueryString } from '@/tool/anchor';
	import {
		index
	} from '@/api/login';
	import Qs from 'qs';
	export default {
		data() {
			return {
				kf: {
					qq:'',
					qq_url:'',
					mobile:'',
					wx:'',
				},
			}
		},
		created() {
			this.getData();
		},
		methods:{
		   md(id){
			   var anchor = this.$el.querySelector('#'+id);//获取元素
			   if(anchor) {
			       setTimeout(()=>{//页面没有渲染完成时是无法滚动的，因此设置延迟
			           anchor.scrollIntoView(); //js的内置方法，可滚动视图位置至元素位置
			       },100);
			   } 
		   },
		   getData() {
		   	index(Qs.stringify()).then(response => {
		   		let r = response.result;
				this.kf = r.kf;
				this.kf.qq_url = "https://wpa.qq.com/msgrd?v=3&uin=" + r.kf.qq + "&site=qq&menu=yes";
		   	})
		   },
		},
		
	}
</script>
<style type="text/css">
.zhandian .container ul li {
    width: 19%;
    margin: 3.0%;
    float: right;
    background: #007AFF;
    border-radius: 30px;
    overflow: hidden;
}
.container .zhandian3 {
    overflow: hidden;
    width: 90%;
    background: #b18dfb;
    border-radius: 300px;
    margin: 2% auto;
    padding: 4% 0;
    background-image: linear-gradient(to right, #b18dfb , #d1a2f0);
}
</style>